import { render, staticRenderFns } from "./versionManage.vue?vue&type=template&id=1c412dfe&scoped=true&"
import script from "./versionManage.vue?vue&type=script&lang=js&"
export * from "./versionManage.vue?vue&type=script&lang=js&"
import style0 from "./versionManage.vue?vue&type=style&index=0&id=1c412dfe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c412dfe",
  null
  
)

export default component.exports